import * as React from "react";
import { twMerge } from "tailwind-merge";
import { copy, heading } from "../styles";

export const Card = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ className, ...rest }, ref) => {
    return (
      <div
        ref={ref}
        className={twMerge(
          "border-ds-stroke-primary bg-ds-surface-foundation text-ds-text-primary rounded-xl border shadow-sm",
          className,
        )}
        {...rest}
      />
    );
  },
);
Card.displayName = "Card";

export const CardHeader = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => (
    <div ref={ref} className={twMerge("flex flex-col gap-1.5 p-6", className)} {...props} />
  ),
);
CardHeader.displayName = "CardHeader";

export const CardTitle = React.forwardRef<HTMLParagraphElement, React.HTMLAttributes<HTMLHeadingElement>>(
  ({ className, children, ...rest }, ref) => {
    return (
      <h3 ref={ref} className={heading({ variant: "16", weight: "medium", className })} {...rest}>
        {children}
      </h3>
    );
  },
);
CardTitle.displayName = "CardTitle";

export const CardDescription = React.forwardRef<HTMLParagraphElement, React.HTMLAttributes<HTMLParagraphElement>>(
  ({ className, ...rest }, ref) => {
    return <p ref={ref} className={copy({ variant: "16", color: "secondary", className })} {...rest} />;
  },
);
CardDescription.displayName = "CardDescription";

export const CardContent = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ className, ...rest }, ref) => {
    return <div ref={ref} className={twMerge("px-6 pb-0", className)} {...rest} />;
  },
);
CardContent.displayName = "CardContent";

export const CardFooter = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ className, ...rest }, ref) => {
    return <div ref={ref} className={twMerge("flex items-center px-6 pb-0", className)} {...rest} />;
  },
);
CardFooter.displayName = "CardFooter";
